import EdoVcDetail from "./EdoVcDetail";

export default EdoVcDetail;
